import { call, put, delay } from "redux-saga/effects";
import { ordersApi } from "@services/api";
import { addCourseToCartActions, getCartActions } from "../slices";

function* addCourseToCartWorker({ payload }) {
  yield delay(300);
  try {
    yield put(addCourseToCartActions.pending());
    const response = yield call(ordersApi.addCourseToCart, payload);
    yield put(addCourseToCartActions.success(response));

    yield put(getCartActions.pending());
    const responseGet = yield call(ordersApi.getCart, payload);
    yield put(getCartActions.success(responseGet));

    // TODO: handle callback | onSuccess
  } catch (error) {
    yield put(addCourseToCartActions.failure(error));
    // TODO: handle callback | onFailure
  }
  if (payload.navigate) {
    yield put(payload.navigate);
  }
}

export { addCourseToCartWorker };
